<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Validasi Ujian" @back="back">
            <a-descriptions bordered>
                <a-descriptions-item label="Sesi Kelas">
                    {{ header.name }}
                </a-descriptions-item>
                <a-descriptions-item label="Waktu kelas dimulai">
                    <template v-if="header.session_time_start != null">
                        {{ moment(header.session_time_start).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Waktu kelas berakhir">
                    <template v-if="header.session_time_end != null">
                        {{ moment(header.session_time_end).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Sesi Ujian">
                    {{ header.name }}
                </a-descriptions-item>
                <a-descriptions-item label="Waktu ujian dimulai">
                    <template v-if="header.actual_exam_time_start != null">
                        {{ moment(header.actual_exam_time_start).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Waktu ujian berakhir">
                    <template v-if="header.actual_exam_time_end != null">
                        {{ moment(header.actual_exam_time_end).format('DD-MM-YYYY HH:mm:ss') }}
                    </template>
                </a-descriptions-item>
                <a-descriptions-item label="Status">
                    <div v-if="roleAdmin && !loading && items.user_exam_attempts.length > 0">
                        <div v-if="header.exam_verification_level >= 1">
                            <a-tag :color="'green'">
                                Sudah divalidasi
                            </a-tag>
                        </div>
                        <div v-else>
                            <a-tag color="red">
                                belum divalidasi
                            </a-tag>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="!loading && items.user_exam_attempts.length > 0">
                            <div v-if="header.exam_verification_level >= 1">
                                <a-tag :color="'green'">
                                    Sudah divalidasi
                                </a-tag>
                            </div>
                            <div v-else>
                                <a-tag color="red">
                                    belum divalidasi
                                </a-tag>
                                <a-button
                                    type="primary"
                                    html-type="submit"
                                    :loading="processing"
                                    :disabled="processing"
                                    @click="showConfirm"
                                    >Validasi</a-button>
                            </div>
                        </div>
                    </div>

                </a-descriptions-item>
            </a-descriptions>
        </a-page-header>

        <a-card type="inner" size="small">
            <div style="margin-bottom: 16px; text-align: right;" v-show="roleAdmin || ispmbk">
                <a-button type="primary" @click="download(routeUri('api.classical-exam-attempt', {session:items.sessions.id}) + '?export=1')">
                    Download
                </a-button>
            </div>
            <a-table
                class="pcp-table"
                :dataSource="items.user_exam_attempts"
                rowKey="hash"
                :loading="loading"
                :pagination="false"
                bordered
                >

                <a-table-column key="photo" title="Foto" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <div style="text-align: center">
                            <img :src="record.photo" v-if="record.photo != null" width="70px" />
                            <a-avatar class="avatar" size="large" shape="circle" v-else>{{ initial(record.name) }}</a-avatar>
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        <a-icon type="user" /> {{ record.name }}
                        <br />
                        <a-icon type="solution" /> {{ record.position }}
                    </template>
                </a-table-column>

                <a-table-column key="gender" title="Gender" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ gender(record.gender) }}
                    </template>
                </a-table-column>

                <a-table-column key="total_question" title="Total Pertanyaan" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].attempts.length > 0">
                            {{ record.activities[0].attempts[0].total_questions }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="total_answer" title="Total Jawaban" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].attempts.length > 0">
                            {{ record.activities[0].attempts[0].total_answered }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="right_answer" title="Jawaban Benar" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].attempts.length > 0">
                            {{ record.activities[0].attempts[0].total_correct_answer }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="score" title="Nilai" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].attempts.length > 0">
                            {{ record.activities[0].attempts[0].raw_score }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="exam_end" title="Ujian Selesai" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="record.activities[0].attempts.length > 0">
                            {{ record.activities[0].attempts[0].ended_at }}
                        </div>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <div v-if="showAdjust">
                            <a-tooltip title="Adjustment Nilai">
                                <a-button
                                :disabled="roleAdmin && header.classical_verification_level > 1"
                                size="small"
                                type="primary"
                                icon="up-square"
                                @click="showModal(record.activities[0].attempts[0])"></a-button>
                            </a-tooltip>
                        </div>
                    </template>
                </a-table-column>

            </a-table>
        </a-card>

        <a-modal
            :destroyOnClose="true"
            :footer="null"
            :visible="visible"
            :closable="false">

            <classical-exam-adjustment-form
                :data="data"
                @handleClose="closeModal"/>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        class_id: {
            type: String,
            required: true
        },
        session: {
            type: String,
            required: true
        },
        previous: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            expand: false,
            visible: false,
            processing: false,
            data: {},
            attendant: null,
            items: {
                user_exam_attempts: []
            },
        };
    },
    created() {
        this.items = this.getDefaultPagination();
        this.filters = _.merge(this.filters, this.$laravel.request);
        this.getItems();
    },
    computed: {
        activeModule() {
            return this.$laravel.active_module
        },
        training() {
            return this.$laravel.training
        },
        training_module() {
            return this.$laravel.training_modules.classical
        },
        roleAdmin() {
            let role = this.$laravel.roles[this.activeModule.module.identifier]

            role = typeof role === "string" ? role : role[0]

            return role == 'admin'
        },
        tableColumns() {
            return this.columns
        },
        examVerifyLevel(){
            return this.items.sessions != null ? this.items.sessions.exam_verification_level.toString() : ""
        },
        ispmbk(){
            return this.$laravel.roles[this.activeModule.module.identifier] == 'project-manager'
        },
        header(){
            return this.items.sessions != null ? this.items.sessions : {}
        },
        showAdjust() {
            if(this.ispmbk && this.header.exam_verification_level == 0)
                return true

            if(this.roleAdmin && this.header.classical_verification_level >= 1)
                return true

            return false
        },
    },
    methods: {
        handleSubmit(e) {
           e.preventDefault(e);

            this.processing = true;

            let promise;

            if(this.examVerifyLevel == ""){
                this.processing = false;
                return
            }

            promise = this.$http.patch(
                this.routeUri("api.classical-exam.verify_exam", {
                    session: this.session
                }),
                {
                    level: parseInt(this.examVerifyLevel)+1
                }
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleReset(e) {
            e.preventDefault();
            this.filters = {
                q: null,
                page: 1
            };
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current;
            this.pushState(this.filters);
            this.getItems();
        },
        getItems() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.classical-exam-attempt", {session: this.session}))
                .then(response => (this.items = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!";

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage;
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            });

            this.getItems();
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        showModal(data) {
            this.data = data;
            this.visible = true;

        },
        closeModal(isRefresh) {
            this.visible = false;
            this.visibleResume = false;

            if (isRefresh == true) {
                this.getItems();
            }
        },
        showConfirm(e) {
            var msg = 'Apakah Anda yakin untuk melanjutkan proses validasi?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleSubmit(e)
                },
                onCancel() {},
                class: 'test',
            });
        },
        back() {
            window.location.href = this.routeUri(this.previous)
        },
        gender(gender){
            switch(gender){
                case "male":
                    return "Laki-laki"
                case "female":
                    return "Perempuan"
                default:
                    return ""
            }
        },
        download(url) {
            window.open(url, '_blank')
        },
    },
}
</script>
